<div class="image-wrapper">
    <div>
        {{imageItem.page}}
        @switch (imageItem.action) {
            @case ('slice') {            
                <i class="pi pi-share-alt"></i>
            }
            @case ('delete') {            
                <i class="pi pi-trash color-trash"></i>
            }
        }
    </div>
    <div class="image-box" >
        <div #image (contextmenu)="onContextMenu($event, imageItem.page)">
            <img [src]="imageItem.url" alt="Image" [style.transform]="'rotate(' + imageItem.rotate + 'deg)'"/>
        </div>
    </div>
</div>
<p-contextMenu #cm [model]="contextMenu" appendTo="body"></p-contextMenu>
